import React, { Component } from 'react';
import { OnHandEnum } from 'Common/FieldEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import ReactTable from 'Common/ReactTableWrapper';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';

class ItemDetailTable extends Component {
  columns = [
    {
      Header: 'Site Id',
      accessor: OnHandEnum.SiteId,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Description',
      accessor: OnHandEnum.Description,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Purchase Quantity',
      accessor: OnHandEnum.PrimaryQty,
      className: 'right-align',
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Reserve Quantity',
      accessor: OnHandEnum.SecondaryQty,
      className: 'right-align',
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Value',
      accessor: OnHandEnum.Value,
      className: 'right-align',
      ...ReactTableWrapperColumnProperties,
    },
    {
      width: 50,
      sortable: false,
    },
  ];
  render() {
    const {
      fetchingOnHands,
      gridPreferenceLoading,
      gridPreferenceSubmitting,
      onHandItems,
      resetPageOnDataChange,
      onResetPageOnDataChange,
    } = this.props;

    return (
      <ReactTable
        loading={
          fetchingOnHands || gridPreferenceLoading || gridPreferenceSubmitting
        }
        noDataText={fetchingOnHands ? '' : 'No items found'}
        defaultPageSize={20}
        showPageSizeOptions={true}
        minRows={5}
        resizable={false}
        className="-striped -highlight"
        data={onHandItems}
        columns={this.columns}
        draggableColumns={true}
        showHideColumn={true}
        menu={'hasCogs'}
        saveState={{
          tableName: TableNamesEnum.ITEM_DETAIL_TABLE,
        }}
        resetPageOnDataChange={resetPageOnDataChange}
        onResetPageOnDataChange={onResetPageOnDataChange}
        gridName={GridEnum.INV_ItemDetail_View}
      />
    );
  }
}

export { ItemDetailTable };



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/components/tables/ItemDetailsTable.js